import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import { FC } from "react";
import { IReservationV2 } from "../../interfaces/reservations/Reservations.types";
import { disputeStatusLabel } from "../../utils/reservations/cancellationText";
import DisputeOperatorPayment from "./DisputeOperatorPayment";

// A card dispute (chargeback) on this booking's payment. While it is open the server refuses
// refunds and Gjirafa Money for the booking, so the banner says so before anyone tries.
// After a lost one, a super admin also decides whether the operator is still paid.
const DisputeBanner: FC<
  Pick<IReservationV2, "hasOpenDispute" | "disputeStatus" | "disputeOperatorPaymentWithheld"> & {
    uniqueJourneyId: string;
    canDecideOperatorPayment: boolean;
    onOperatorPaymentChanged: () => void;
  }
> = ({
  hasOpenDispute,
  disputeStatus,
  disputeOperatorPaymentWithheld: withheld,
  uniqueJourneyId,
  canDecideOperatorPayment,
  onOperatorPaymentChanged
}) => {
  const status = disputeStatusLabel(disputeStatus);
  if (hasOpenDispute)
    return (
      <div role="alert" className="flex items-start gap-2 rounded-md border border-red-300 bg-red-100/50
        px-3 py-2 text-sm text-red-700">
        <ExclamationTriangleIcon className="w-5 h-5 shrink-0" />
        <span>
          <strong>Kontestim i hapur{status ? ` (${status})` : ""}.</strong> Klienti e ka kontestuar
          pagesën te banka. Derisa të mbyllet, rimbursimet dhe Gjirafa Money për këtë rezervim
          refuzohen; financat janë njoftuar.
        </span>
      </div>
    );
  if (!status) return null;
  const lost = disputeStatus?.toLowerCase() === "lost";
  if (lost && withheld !== null && withheld !== undefined)
    return (
      <div className="flex flex-col gap-2 rounded-md border border-gray-200 bg-gray-50 px-3 py-2 text-xs
        text-gray-600">
        <p className="text-xs">
          Kontestimi i pagesës {status}. Rezervimi shënohet i rimbursuar; financat e regjistrojnë me
          dorë.
        </p>
        {canDecideOperatorPayment ? (
          <DisputeOperatorPayment uniqueJourneyId={uniqueJourneyId} withheld={withheld}
            onDone={onOperatorPaymentChanged} />
        ) : (
          <strong className="text-black">
            {withheld ? "Pagesa e operatorit është ndalur" : "Operatori paguhet"}
          </strong>
        )}
      </div>
    );
  return (
    <p className="rounded-md border border-gray-200 bg-gray-50 px-3 py-2 text-xs text-gray-600">
      Kontestimi i pagesës {status}.
      {lost && " Rezervimi shënohet i rimbursuar; financat e regjistrojnë me dorë."}
    </p>
  );
};

export default DisputeBanner;
